<template>
  <div class="ftp-users-page">
    <h1>
      {{ $t('console.ftpUsers') }}
      <v-btn
        icon="mdi-help-circle-outline"
        @click="showingHelpDialog = true"
        rounded="circle"
        width="36"
        height="36"
        elevation="0"
      />
    </h1>
    <v-card elevation="0">
      <v-container fluid>
        <v-row>
          <v-col>
            <FTPUsersListView :ftp-users="ftpUsers" @refresh="refreshList" />
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <FTPUsersHelpDialog v-model="showingHelpDialog" />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useFtpUserStore } from '@/stores/FtpUserStore.js';
import FTPUsersListView from './components/FTPUsersListView.vue';
import FTPUsersHelpDialog from './components/dialogs/FTPUsersHelpDialog.vue';

export default {
  name: 'FTPUsersIndex',
  components: {
    FTPUsersListView,
    FTPUsersHelpDialog,
  },
  data() {
    return {
      showingHelpDialog: false,
    };
  },
  async mounted() {
    if (!this.user) {
      const authStore = useAuthStore();
      await authStore.refreshDBUser();
    }

    if (!this.$canControlTenantConfig()) {
      this.$router.push('/console/index');
      return;
    }

    this.refreshList();
  },
  methods: {
    async refreshList() {
      const authStore = useAuthStore();
      const ftpuserStore = useFtpUserStore();
      await ftpuserStore.refreshFtpUserList(authStore.rootNodeId);
    },
  },
  computed: {
    ftpUsers() {
      const ftpuserStore = useFtpUserStore();
      return ftpuserStore.ftpUserList;
    },
  },
};
</script>

<style scoped>
.ftp-users-page {
  padding: 1rem;
}
</style>
